import React, {Component} from 'react';
import {matchRoutes} from 'react-router-config'
import ChevronRight from 'react-feather/dist/icons/chevron-right.js';
import ChevronLeft from 'react-feather/dist/icons/chevron-left.js';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {toastr} from 'react-redux-toastr';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import DefaultLayout from '../../Layout/DefaultLayout.jsx';
import Navbar from '../../Navbar/Navbar.jsx';
import SearchNavbar from './SearchNavbar.jsx';

import actions from '../../Errors/actions.js';
import connectPagination from '../HOC/Pagination.js';
import {generate} from '../../../routes.js';
import {isAdmin} from '../../../../shared/services/userService.js';
import routes from '../../../routes.js';

import './SearchView.scss';

class SearchView extends Component {
  static propTypes = {
    flattenSearchObject: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    searchQuery: PropTypes.object.isRequired,
    searchData: PropTypes.object.isRequired,
    searchRouteName: PropTypes.string.isRequired,
    title: PropTypes.string,
    viewRouteName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isAdmin: false,
    title: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      results: props.searchData.results,
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if(
      (JSON.stringify(this.props.searchData.results) !== JSON.stringify(prevProps.searchData.results)) ||
      (this.props.searchData.loading !== prevProps.searchData.loading)
    ) {
      this.setState({
        results: this.props.searchData.results
      });
    }
  }

  onFormSuccess = (message = null) => {
    toastr.success(message ? message : 'Les modifications ont correctement été enregistrées');
  }

  getNextLink = () => {
    let newPosition = parseInt(this.props.match.params.offset, 10) + 1;
    const searchObject = {...this.props.searchQuery};

    const searchPage = parseInt(searchObject.page, 10);

    if (searchPage === this.props.pagination.pageCount && newPosition >= this.props.pagination.currentItemCount) {
      return null;
    }

    if (newPosition >= this.props.pagination.itemsPerPage) {
      newPosition = 0;
      searchObject.page = searchPage + 1;
    }

    const matchedRoutes = matchRoutes(routes, this.props.location.pathname);
    const routeName = matchedRoutes[matchedRoutes.length - 1].route.name;

    return generate({
      name: `${this.props.viewRouteName}.${routeName}`,
      parameters: {offset: newPosition, page: searchObject.page},
      search: this.props.flattenSearchObject(searchObject)
    });
  };

  getPrevLink = () => {
    let newPosition = parseInt(this.props.match.params.offset, 10) - 1;
    const searchObject = {...this.props.searchQuery};
    if (newPosition < 0) {
      newPosition = this.props.pagination.itemsPerPage - 1;
      const searchPage = parseInt(searchObject.page, 10);
      if ((searchPage - 1) < this.props.pagination.startPage) {
        return null;
      }
      searchObject.page = searchPage - 1;
    }

    const matchedRoutes = matchRoutes(routes, this.props.location.pathname);
    const routeName = matchedRoutes[matchedRoutes.length - 1].route.name;

    return generate({
      name: `${this.props.viewRouteName}.${routeName}`,
      parameters: { offset: newPosition, page: searchObject.page },
      search: this.props.flattenSearchObject(searchObject)
    });
  };

  getPosition = () => {
    return (
      (this.props.pagination.currentPage - 1) * this.props.pagination.itemsPerPage +
      parseInt(this.props.match.params.offset, 10)
    );
  };

  render() {
    const {flattenSearchObject, pagination, searchQuery, searchRouteName} = this.props;

    const nextLink = this.getNextLink();
    const prevLink = this.getPrevLink();

    const navbar = (
      <Navbar className={this.state.results.length > 0 ? 'visible' : 'hidden'} contained={false} fixed locked visible>
        <SearchNavbar
          currentPosition={this.getPosition() + 1}
          nextLink={nextLink}
          prevLink={prevLink}
          searchLink={generate({
            name: searchRouteName,
            search: flattenSearchObject(searchQuery)
          })}
          total={pagination.total}
        >
          {this.props.title}
        </SearchNavbar>
      </Navbar>
    );

    return (
      <DefaultLayout className={`search-view ${searchQuery.target}-search-view`} navbar={navbar}>
        {this.props.children}
        {prevLink &&
          <Link to={prevLink} className={`prev-profil ${this.state.results.length? 'visible' : 'hidden'}`}>
            <ChevronLeft />
          </Link>
        }
        {nextLink &&
          <Link to={nextLink} className={`next-profil ${this.state.results.length ? 'visible' : 'hidden'}`}>
            <ChevronRight />
          </Link>
        }
      </DefaultLayout>
    );
  }
}

export default connect(
  (state) => ({
    pagination: state.search.pagination,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  }),
  (dispatch) => bindActionCreators({...actions}, dispatch)
)(connectPagination()(SearchView));